<template>
  <NuxtLayout name="catalog">
    <div class="page-login">
      <div class="page-container">
        <MoleculesGlobalBreadcrumb :segments="[{ name: $t('Přihlášení'), level: 0 }]"></MoleculesGlobalBreadcrumb>
      </div>
      <div class="bg-neutral-100">
        <div class="page-container text-center">
          <div class="inline-block w-full mb-6 text-center tablet:mb-12 tablet:w-[550px]">
            <strong class="block text-3xl my-6 tracking-normal tablet:my-12">{{ $t('Přihlášení k účtu na Rigad') }}</strong>
            <div class="p-6 border border-neutral-200 bg-neutral-50 tablet:p-12">
              <div class="mb-12 tracking-normal text-left">
                <AtomsImagesIcon icon="user" class="mr-4" /> {{ $t('Ještě nemám účet a ') }} <AtomsTextLink class="underline text-primary-500" :href="cache.getModuleUrl('modules/register')">{{ $t('chci se registrovat') }}</AtomsTextLink>
              </div>
              <TemplatesLogin @logged="redirectToProfile" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>
<script setup>

const cache = useCache();

const redirectToProfile = () => {
  nextTick(() => {
    useRouter().push(cache.getModuleUrl('modules/account/myAccount'));
  });
};

</script>